<template>
  <div class="numbers">
    <h2 class="numbers__title">{{labels.numbers.title}}</h2>
    <p class="numbers__info">{{labels.numbers.info}}</p>
    <text-balloon
      :speed="5"
      :isPaused="false"
      class="numbers__invader"
      @click.native="invaderClicked"
      :text="invaderText"
    />
    <h2 class="numbers__title">{{labels.numbers.cyberattacks.title}}</h2>
    <div class="numbers__step numbers__step--one">
      <div class="numbers__step-indicator">
        <p>1.</p>
      </div>
      <invader
        :speed="3.8"
        :loops="1"
        :isPaused="invaderOnePaused"
        :showDeadWhenPaused="false"
        class="numbers__invader--background"
        ref="invaderOne"
      />
      <circle-graph
        :maxPercentage="labels.numbers.cyberattacks.total.percentage"
        :description="labels.numbers.cyberattacks.total.description"
        class="numbers__circle-graph"
      />
    </div>
    <invader
      :speed="4"
      :loops="1"
      :isPaused="invaderTwoPaused"
      :showDeadWhenPaused="false"
      class="numbers__invader"
      ref="invaderTwo"
    />
    <div class="numbers__step numbers__step--two">
      <div class="numbers__step-indicator">
        <p>2.</p>
      </div>
      <h2 class="numbers__subtitle">{{labels.numbers.cyberattacks.types.title}}</h2>
    </div>
    <div class="numbers__bar-graph-wrapper">
      <bar-graph
        class="numbers__bar-graph"
        v-for="(item, index) in labels.numbers.cyberattacks.types.data"
        v-bind="item"
        :key="index"
      />
    </div>
  </div>
</template>

<script>
import Invader from "./Invader.vue";
import TextBalloon from "./TextBalloon.vue";
import CircleGraph from "./Graphs/Circle.vue";
import BarGraph from "./Graphs/Bar.vue";

import { mapGetters } from "vuex";
import { vuexGetters } from "../store";
export default {
  name: "Numbers",
  components: {
    Invader,
    CircleGraph,
    BarGraph,
    TextBalloon
  },
  data() {
    return {
      clickedInvader: false,
      invaderOnePaused: false,
      invaderTwoPaused: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.invaderOnePaused = true;
    }, 3000);
    setTimeout(() => {
      this.invaderTwoPaused = true;
    }, 1500);
  },
  computed: {
    ...mapGetters({
      labels: vuexGetters.I18N
    }),
    invaderText() {
      return this.clickedInvader
        ? this.labels.numbers.invader.reaction
        : this.labels.numbers.invader.cta;
    }
  },
  methods: {
    invaderClicked() {
      this.clickedInvader = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.numbers {
  padding: 40px 25px;

  @media screen and (min-width: 544px) {
    display: block;
    max-width: 494px;
    margin: 0 auto;
  }

  &__invader {
    margin-bottom: 60px;

    &--background {
      position: absolute;
      left: 0;
      right: 0;
    }
  }

  &__title {
    color: $eminence;
    font-size: 1.75rem;
    font-weight: 300;
    line-height: 2.125rem;
    text-align: center;

    @media screen and (min-width: 544px) {
      text-align: left;
    }
  }

  &__info {
    display: block;
    font-size: 0.8125rem;
    line-height: 1.5rem;
    margin: 20px 0;
    text-align: center;

    @media screen and (min-width: 544px) {
      font-size: 0.9375rem;
      line-height: 1.5rem;
      text-align: left;
    }
  }

  &__circle-graph {
    max-width: 234px;
    margin: 20px auto;

    @media screen and (min-width: 544px) {
      margin-top: 50px;
    }
  }

  &__step {
    position: relative;
  }

  &__step-indicator {
    position: absolute;
    left: -25px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;

    @media screen and (min-width: 544px) {
      align-items: flex-start;
      left: -80px;
    }

    p {
      background: rgba($eminence, 0.5);
      color: $white;
      line-height: 33px;
      display: block;
      width: 48px;
      text-align: center;
    }
  }

  &__subtitle {
    color: $eminence;
    display: block;
    font-size: 0.8125rem;
    line-height: 1rem;
    margin-left: 51px;

    @media screen and (min-width: 544px) {
      margin-left: 0;
      font-size: 1rem;
      line-height: 33px;
    }
  }

  &__bar-graph-wrapper {
    margin-top: 40px;
  }
}
</style>